export default "__VITE_ASSET__ecf08f21__"